import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import TextField from '../../../../shared-components/TextField/TextField';

const LOCALE_PREFIX = 'GB/components/Address/Address';

export class Street2 extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        ariadescribedby: PropTypes.string,
        idPrefix: PropTypes.string
    };

    render() {
        const { intl, idPrefix, ariadescribedby } = this.props;

        return (
            <div>
                <Field
                    id={idPrefix ? `${idPrefix}-street2` : 'street2'}
                    name="street2"
                    autoComplete="disabled"
                    required={false}
                    ariadescribedby={ariadescribedby}
                    component={TextField}
                    label={intl.formatMessage({id: `${LOCALE_PREFIX}.addressLine2`})}
                />
            </div>
        );
    }
}

export default injectIntl(Street2);
